<template>
  <div>
    <PartnerHeader :img_header="header_image" header="รายงานกำไรขาดทุน" link_back="managepos" />

    <v-card elevation="6">
      <div class="pa-3">
        <v-tabs v-model="currentTab" grow color="#86bc3a" slider-color="#86bc3a" active-class="active-tab">
          <v-tab style="font-size: 18px">กำไรขาดทุน Vat</v-tab>
          <v-tab style="font-size: 18px">กำไรขาดทุน No Vat</v-tab>
        </v-tabs>
      </div>

      <v-divider></v-divider>

      <div class="ma-4">
        <!-- ฟิลเตอร์วันที่ -->
        <v-row class="mb-4">
          <v-col cols="12" md="4">
            <v-menu v-model="startDateMenu" :close-on-content-click="false" transition="scale-transition" offset-y
              min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="startDate" label="วันที่เริ่มต้น" prepend-icon="mdi-calendar" readonly
                  v-bind="attrs" v-on="on" color="#86bc3a"></v-text-field>
              </template>
              <v-date-picker v-model="startDate" @input="startDateMenu = false" color="#86bc3a"></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" md="4">
            <v-menu v-model="endDateMenu" :close-on-content-click="false" transition="scale-transition" offset-y
              min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="endDate" label="วันที่สิ้นสุด" prepend-icon="mdi-calendar" readonly
                  v-bind="attrs" v-on="on" color="#86bc3a"></v-text-field>
              </template>
              <v-date-picker v-model="endDate" @input="endDateMenu = false" color="#86bc3a"></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" md="4" class="d-flex align-center">
            <v-btn color="#86bc3a" dark @click="fetchProfitLossData" :loading="loading">
              <v-icon left>mdi-magnify</v-icon>
              ค้นหา
            </v-btn>
          </v-col>
        </v-row>

        <v-row class="mb-4">
          <v-col cols="12" md="8"></v-col>
          <v-col cols="12" md="4" class="d-flex justify-end">
            <v-btn color="#4CAF50" dark @click="exportToExcel" :disabled="loading">
              <v-icon left>mdi-microsoft-excel</v-icon>
              Export Excel
            </v-btn>
          </v-col>
        </v-row>

        <!-- ช่องค้นหา -->
        <v-card-title class="px-0">
          <v-text-field v-model="search" append-icon="mdi-magnify" label="ค้นหา" color="#86bc3a" single-line
            hide-details></v-text-field>
        </v-card-title>

        <!-- Tab Content -->
        <v-tabs-items v-model="currentTab">
          <!-- Tab 1: กำไรขาดทุน Vat -->
          <v-tab-item>
            <v-data-table :headers="headersVat" :items="profitLossDataVat" :footer-props="footerProps" :search="search"
              :loading="loading" mobile-breakpoint="0" class="mt-4">
              <template v-slot:item.date="{ item }">
                {{ item.date }}
              </template>

              <template v-slot:item.invoiceNumber="{ item }">
                {{ item.invoiceNumber }}
              </template>

              <template v-slot:item.cost="{ item }">
                {{ formatNumber(item.cost) }}
              </template>

              <template v-slot:item.memberCode="{ item }">
                {{ item.memberCode }}
              </template>

              <template v-slot:item.memberName="{ item }">
                {{ item.memberName }}
              </template>

              <template v-slot:item.inVat="{ item }">
                {{ formatNumber(item.inVat) }}
              </template>

              <template v-slot:item.exVat="{ item }">
                {{ formatNumber(item.exVat) }}
              </template>

              <template v-slot:item.profit="{ item }">
                <span :style="{ color: item.profit >= 0 ? 'green' : 'red' }">
                  {{ formatNumber(item.profit) }}
                </span>
              </template>

              <template v-slot:no-data>
                <div class="text-center pa-4">
                  ไม่พบข้อมูล
                </div>
              </template>
            </v-data-table>
          </v-tab-item>

          <!-- Tab 2: กำไรขาดทุน No Vat -->
          <v-tab-item>
            <v-data-table :headers="headersNoVat" :items="profitLossDataNoVat" :footer-props="footerProps"
              :search="search" :loading="loading" mobile-breakpoint="0" class="mt-4">
              <template v-slot:item.date="{ item }">
                {{ item.date }}
              </template>

              <template v-slot:item.invoiceNumber="{ item }">
                {{ item.invoiceNumber }}
              </template>

              <template v-slot:item.cost="{ item }">
                {{ formatNumber(item.cost) }}
              </template>

              <template v-slot:item.memberCode="{ item }">
                {{ item.memberCode }}
              </template>

              <template v-slot:item.memberName="{ item }">
                {{ item.memberName }}
              </template>

              <template v-slot:item.inVat="{ item }">
                {{ formatNumber(item.inVat) }}
              </template>

              <template v-slot:item.profit="{ item }">
                <span :style="{ color: item.profit >= 0 ? 'green' : 'red' }">
                  {{ formatNumber(item.profit) }}
                </span>
              </template>

              <template v-slot:no-data>
                <div class="text-center pa-4">
                  ไม่พบข้อมูล
                </div>
              </template>
            </v-data-table>
          </v-tab-item>
        </v-tabs-items>
      </div>
    </v-card>
  </div>
</template>

<script>
import PartnerHeader from "@/components/admin/manage_pos/partner_store_setting/menu_partner_store/PartnerHeader";
import img_money_bag_report from "@/assets/money-bag-report.png";
import axios from 'axios';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export default {
  name: "ReportProfitLoss",
  components: {
    PartnerHeader,
  },
  data() {
    return {
      header_image: img_money_bag_report,
      currentTab: 0,
      search: '',
      loading: false,
      startDate: null,
      endDate: null,
      startDateMenu: false,
      endDateMenu: false,
      footerProps: {
        'items-per-page-text': 'รายการต่อหน้า',
        'items-per-page-options': [10, 20, 50, 100, -1]
      },
      headersVat: [
        { text: 'วันที่', value: 'date', sortable: true },
        { text: 'เลขที่บิล', value: 'invoiceNumber', sortable: true },
        { text: 'ต้นทุน', value: 'cost', sortable: true, align: 'end' },
        { text: 'รหัสสมาชิก', value: 'memberCode', sortable: true },
        { text: 'ชื่อสมาชิก', value: 'memberName', sortable: true },
        { text: 'In Vat', value: 'inVat', sortable: true, align: 'end' },
        { text: 'Ex Vat', value: 'exVat', sortable: true, align: 'end' },
        { text: 'กำไร', value: 'profit', sortable: true, align: 'end' },
      ],
      headersNoVat: [
        { text: 'วันที่', value: 'date', sortable: true },
        { text: 'เลขที่บิล', value: 'invoiceNumber', sortable: true },
        { text: 'ต้นทุน', value: 'cost', sortable: true, align: 'end' },
        { text: 'รหัสสมาชิก', value: 'memberCode', sortable: true },
        { text: 'ชื่อสมาชิก', value: 'memberName', sortable: true },
        { text: 'In Vat', value: 'inVat', sortable: true, align: 'end' },
        { text: 'กำไร', value: 'profit', sortable: true, align: 'end' },
      ],
      profitLossDataVat: [],
      profitLossDataNoVat: []
    }
  },
  watch: {
    currentTab() {
      // this.profitLossDataVat = [];
      // this.profitLossDataNoVat = [];
      this.search = '';
      this.fetchProfitLossData();
    }
  },
  mounted() {
    const today = new Date();
    this.startDate = today.toISOString().substr(0, 10);
    this.endDate = today.toISOString().substr(0, 10);

    // โหลดข้อมูลเมื่อเริ่มต้น
    this.fetchProfitLossData();
  },
  methods: {
    formatNumber(value) {
      if (value === null || value === undefined) return '0.00';
      return parseFloat(value).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },

    async fetchProfitLossData() {
      if (!this.startDate || !this.endDate) {
        alert('กรุณาเลือกวันที่เริ่มต้นและวันที่สิ้นสุด');
        return;
      }

      if (this.startDate > this.endDate) {
        alert('วันที่สิ้นสุดต้องมากกว่าหรือเท่ากับวันที่เริ่มต้น');
        return;
      }

      this.loading = true;

      try {
        const apiUrl = `${process.env.VUE_APP_BASE_URL}/report-profit-loss`;

        console.log('Calling API:', apiUrl);
        console.log('Params:', { start_date: this.startDate, end_date: this.endDate });
        const vatType = this.currentTab === 0 ? 'vat' : 'no_vat';

        const response = await axios.get(apiUrl, {
          params: {
            start_date: this.startDate,
            end_date: this.endDate,
            vat_type: vatType
          }
        });

        if (response.data.success) {
          if (this.currentTab === 0) {
            this.profitLossDataVat = response.data.data;
          } else {
            this.profitLossDataNoVat = response.data.data;
          }
          // แยกข้อมูลตาม Tab (ในกรณีนี้ข้อมูลเหมือนกัน แต่สามารถแยกได้ถ้ามีเงื่อนไข)
          // this.profitLossDataVat = response.data.data;
          // this.profitLossDataNoVat = response.data.data;

          console.log('โหลดข้อมูลสำเร็จ:', response.data.data.length, 'รายการ');
        }
      } catch (error) {
        console.error('Error fetching profit/loss data:', error);

        if (error.response) {
          // Server ตอบกลับมาแต่มี error
          console.error('Response error:', error.response.data);
          alert(`เกิดข้อผิดพลาด: ${error.response.data.message || 'ไม่สามารถโหลดข้อมูลได้'}`);
        } else if (error.request) {
          // ส่ง request ไปแต่ไม่ได้รับ response
          console.error('Request error:', error.request);
          alert('ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้ กรุณาตรวจสอบว่า Laravel Backend กำลังรันอยู่');
        } else {
          alert('เกิดข้อผิดพลาด: ' + error.message);
        }
      } finally {
        this.loading = false;
      }
    },

    exportToExcel() {
      // ตรวจสอบว่ามีข้อมูลหรือไม่
      const dataToExport = this.currentTab === 0 ? this.profitLossDataVat : this.profitLossDataNoVat;

      if (dataToExport.length === 0) {
        alert('ไม่มีข้อมูลให้ Export');
        return;
      }

      // เตรียมข้อมูลสำหรับ export
      const exportData = dataToExport.map(item => {
        const row = {
          'วันที่': item.date,
          'เลขที่บิล': item.invoiceNumber,
          'ต้นทุน': item.cost,
          'รหัสสมาชิก': item.memberCode,
          'ชื่อสมาชิก': item.memberName,
          'In Vat': item.inVat,
        };

        // เพิ่มคอลัมน์ Ex Vat เฉพาะ Tab Vat
        if (this.currentTab === 0) {
          row['Ex Vat'] = item.exVat;
        }

        row['กำไร'] = item.profit;

        return row;
      });

      // สร้าง workbook และ worksheet
      const ws = XLSX.utils.json_to_sheet(exportData);
      const wb = XLSX.utils.book_new();

      // ตั้งชื่อ sheet ตาม Tab ที่เลือก
      const sheetName = this.currentTab === 0 ? 'กำไรขาดทุน Vat' : 'กำไรขาดทุน No Vat';
      XLSX.utils.book_append_sheet(wb, ws, sheetName);

      // สร้างไฟล์ Excel
      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

      // ตั้งชื่อไฟล์ตามช่วงวันที่
      const fileName = `รายงานกำไรขาดทุน_${this.startDate}_${this.endDate}.xlsx`;

      // บันทึกไฟล์
      saveAs(new Blob([wbout], { type: 'application/octet-stream' }), fileName);
    },

    page(tabNumber) {
      this.currentTab = tabNumber - 1;
    }
  }
}
</script>

<style scoped>
::v-deep .v-data-table th {
  font-size: 16px !important;
  background-color: #f5f5f5;
}

::v-deep .v-data-table tbody tr {
  border-bottom: 1px solid #e0e0e0;
}

::v-deep .v-data-table tbody tr:hover {
  background-color: #fafafa !important;
}

::v-deep .v-tabs-items {
  background-color: transparent;
}

::v-deep .v-tab {
  text-transform: none !important;
}
</style>